import { render, staticRenderFns } from "./Parametres.vue?vue&type=template&id=6949b18f&scoped=true"
import script from "./Parametres.vue?vue&type=script&lang=js"
export * from "./Parametres.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6949b18f",
  null
  
)

export default component.exports